import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { OrganizationSubscription } from './models/organization-subscription.model';
import { OrganizationSubscriptionPortalLinkType } from './organization-subscription.service';
import { EntityServiceError } from '../shared/errors/entity-service.error';
import { ExternalLink } from './models/external-link.model';

export const ManageSubscriptionButtonsActions = createActionGroup({
  source: 'Manage Subscription Buttons',
  events: {
    Clicked: props<{ linkType: OrganizationSubscriptionPortalLinkType }>(),
    Promo: props<{ couponId: string; priceId: string }>(),
  },
});

export const OrganizationSubscriptionEffectActions = createActionGroup({
  source: 'Organization Subscription Effect',
  events: {
    'Load Subscription': emptyProps(),
    'Load Subscription Succeeded': props<{ subscription: OrganizationSubscription }>(),
    'Load Subscription Errored': props<{ error: EntityServiceError }>(),
    'Generate Billing Portal Link Succeeded': props<{ link: ExternalLink }>(),
    'Generate Billing Portal Link Errored': props<{ error: EntityServiceError }>(),
    'Open Billing Portal Succeeded': props<{ link: ExternalLink }>(),
  },
});
